import { render, staticRenderFns } from "./Referee.vue?vue&type=template&id=6224bf5c&scoped=true"
import script from "./Referee.vue?vue&type=script&lang=js"
export * from "./Referee.vue?vue&type=script&lang=js"
import style0 from "./Referee.vue?vue&type=style&index=0&id=6224bf5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6224bf5c",
  null
  
)

export default component.exports